// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"357370d0","382":"df37405c","430":"5a1cbb7e","453":"dda07396","472":"8a359de2","523":"f9b1290c","618":"283e6bbd","746":"949b0dd2","798":"9068b1be"}[chunkId] + ".chunk.js";
};